module.exports = __webpack_public_path__ + "static/media/map area - 375 x 387.f3b396d2.png";